import {
  enableCustomApprovalsWithCustomWorkflow,
  isWorkflowBuilderEnabled,
  isWorkflowBuilderUpsellEnabled,
} from '@gonfalon/dogfood-flags/dogfood-flags';

import { useCurrentEnvironmentEntity } from '#reducers/projects';

export function useWorkflowsFeatureEnablement() {
  const currentEnvironment = useCurrentEnvironmentEntity();
  const isWorkflowBuilderDisabledDueToApprovalSettings =
    currentEnvironment?.hasIntegrationApproval() && !enableCustomApprovalsWithCustomWorkflow();
  return {
    currentEnvironment,
    isWorkflowBuilderEnabled: isWorkflowBuilderEnabled() && !isWorkflowBuilderDisabledDueToApprovalSettings,
    isWorkflowBuilderUpsellEnabled: isWorkflowBuilderUpsellEnabled() && !isWorkflowBuilderDisabledDueToApprovalSettings,
    isWorkflowBuilderDisabledDueToApprovalSettings,
  };
}
